<template>
  <BaseWeb :logo-img="logoPhoto"
           :app-img-arr="appPhotoArr" :app-name="appName" :company="companyName" :icp-num="icpNum"
           class="many_recruit_btn" :download-path="downloadPath" :one-word="oneWord" :tow-word="towWord"></BaseWeb>
</template>

<script>
import BaseWeb from '../components/baseWeb'
export default {
  name: "earnChange",
  components:{
    BaseWeb:BaseWeb
  },
  data(){
    return{
      logoPhoto:require('../assets/earnImg/logo.png'),
      appPhotoArr:[
        {id:1,photo:require('../assets/earnImg/newOne.png')},
        {id:2,photo:require('../assets/earnImg/newTow.png')},
        {id:3,photo:require('../assets/earnImg/newThree.png')},
        {id:4,photo:require('../assets/earnImg/newFour.png')},
      ],
      appName:'零钱赚',
      companyName:'厦门叮尼科技有限公司',
      icpNum:'闽ICP备2021018916号-1',
      downloadPath:'http://apk.hotbuybuy.com/lqz_baidu_100_100_jiagu_sign.apk',
      oneWord:'脑筋动一动！\n' +
        '零钱赚是一款益智类答题软件，有着上千道题目等你来挑战，不仅有天文地理，人文历史，还有生活小常识等趣味题目噢。页面清爽整洁，让你尽情体验答题带来的思维盛宴，答题可获得经验升级，提升等级！',
      towWord:' '
    }
  }
}
</script>

<style scoped>
.many_recruit_btn{
  --downBtn:rgb(255,94,42);
}
</style>



// WEBPACK FOOTER //
// src/components/earnChange.vue